<template>
    <div v-if="body_show">
        <div class="achievement-box clearfix">
            <ul class="clearfix">
                <li v-for=" (item,index) in data" :key="index">
                    <img v-if="item.link!=''" :src="item.pic" @click="clickHandle(item.link,item.pop_status)" >
                    <img v-else :src="item.pic">
                </li>
            </ul>
        </div>
        <!-- 卡片弹出层 -->
        <public-card :imgLink="imgUrl" h4="还可在个人中心查看" h3="长按上方图片保存分享好友或朋友圈" ref="card" ></public-card>
    </div>
</template>

<script>
import { achievement } from "@/api/person"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            body_show:false,
            data:{},
            imgUrl:''
        }
    },
    methods:{
        // 初始化获取数据函数
        pullData() {
            achievement().then(data => {
                this.body_show = true;
                this.data = data;
            });
        },
        // 单击成就图标执行函数
        clickHandle(srcs,static_){
            if(static_ && static_==1){
                this.imgUrl = srcs;
                this.$refs.card.card_show = true;
            }else{
                window.location.href = srcs;
            }
        }
    },
    created() {
      this.pullData();
      shareCon("index",this);
    }
}
</script>

<style lang="scss" scoped>
    .achievement-box{
        padding: 40px 30px;
        ul{
            li{
                width: 180px;
                height: 180px;
                float: left;
                margin-right: 75px;
                margin-bottom: 60px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            li:nth-child(3n+0){
                margin-right: 0;
            }
        }
    }
</style>
